/*
  Отчёт об ошибке для поддержки (R42): короткий код и текст «Подробностей для поддержки». Код считается от
  имени и текста ошибки, поэтому одна и та же ошибка у разных людей даёт один код — по нему её находят в
  журнале. Настоящая отправка в трассировку — зона ядра (spec-2 §11).
*/

/** Код ошибки вида K-7F3A: четыре знака хэша FNV-1a от имени и текста. */
export function errorCode(error: Error): string {
  let h = 0x811c9dc5;
  for (const ch of `${error.name}:${error.message}`) {
    h ^= ch.codePointAt(0) ?? 0;
    h = Math.imul(h, 0x01000193);
  }
  return `K-${((h >>> 0) & 0xffff).toString(16).toUpperCase().padStart(4, '0')}`;
}

/** Текст для поддержки: код и имя ошибки, её текст и, если известно, где она случилась. */
export function errorDetails(error: Error, where?: string): string {
  return [`${errorCode(error)} · ${error.name}`, error.message, where].filter(Boolean).join('\n');
}

/** Ключи сохранённых вкладок и окон (kaname.<место>.workspace.<версия>). */
const WORKSPACE_KEY = /^kaname\.(?:[^.]+\.)*workspace\./;

/**
 * «Открыть без восстановления вкладок»: забыть сохранённые вкладки и окна и перезагрузить страницу.
 * Хранилище недоступно (приватное окно, запрет) — просто перезагрузка.
 */
export function reloadWithoutTabs(): void {
  try {
    for (const key of Object.keys(window.localStorage)) {
      if (WORKSPACE_KEY.test(key)) window.localStorage.removeItem(key);
    }
  } catch {
    // Хранилище закрыто — вкладки и так не восстановятся из него.
  }
  window.location.reload();
}
